import { Control, Controller } from "react-hook-form";
import { Field } from "@/components/ui/field";
import {
    Select as ReactSelect
} from "chakra-react-select";
import { LabelAndValueOption } from "@/data/LabelAndValueOption";

export const ProjectSelectController = ({ control, projectNames, name, label, readOnly, ...props }:
    { control: Control<any, any>, projectNames: LabelAndValueOption[], name: string, label: string, readOnly: boolean, [key: string]: any }) => {
    const mandatory = props['required'] ?? false;
    return (<Controller control={control} name={name}
        rules={{ required: mandatory && "Projekt auswählen", validate: (value) => !mandatory || value > -1 || "Projekt auswählen" }}
        render={({ field: { value, name, onChange, onBlur, ref }, fieldState: { error, invalid } }) => (
            <Field id={name} label={label} required={mandatory} disabled={readOnly} invalid={invalid} errorText={error?.message}>
                <ReactSelect
                    isSearchable
                    isClearable={!mandatory}
                    placeholder='Projekt'
                    required={mandatory}
                    isDisabled={readOnly}
                    autoFocus={false}
                    ref={ref}
                    name={name}
                    onBlur={onBlur}
                    options={projectNames}
                    onChange={val => {
                        //console.log(`RS onChange:${val}`);
                        onChange(val?.value ?? null);
                    }}
                    value={projectNames.find(c => c?.value === value)}
                />
            </Field>
        )} />);
}